import { render } from "./AdminExamResultManagement.vue?vue&type=template&id=6e3a20f6&scoped=true"
import script from "./AdminExamResultManagement.vue?vue&type=script&lang=js"
export * from "./AdminExamResultManagement.vue?vue&type=script&lang=js"

import "./AdminExamResultManagement.vue?vue&type=style&index=0&id=6e3a20f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e3a20f6"]])

export default __exports__